export enum KustomerBaseUrl {
  Production = 'https://affecttherapeutics.kustomerapp.com',
  Staging = 'https://affecttherapeutics-sandbox.kustomerapp.com'
}
